import { useState } from 'react';

// TODO: after xstate update should be replaced with the hook from @xstate/react
export default function useMachine(machine) {
  const [state, setState] = useState(machine.initialState);
  const transition = (event, data) => setState(machine.transition(state.value, event, data));

  return [state, transition];
}